module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "CT",
    attrs: {
      "id": "_idParaDest-5"
    }
  }, [_vm._v("ACKNOWLEDGMENTS")]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-7"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Cardiff, by the Sea ")]), _vm._v("first appeared in "), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Ellery Queen.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Miao Dao ")]), _vm._v("was an Amazon original.")]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Phantomwise: 1972 ")]), _vm._v("first appeared in "), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("Ellery Queen")]), _vm._v(" and was reprinted in "), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The Best American Mystery Stories 2019.")])]), _vm._v(" "), _c('p', {
    staticClass: "BT1stPara ParaOverride-9"
  }, [_c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The Surviving Child ")]), _vm._v("first appeared in"), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v(" Echoes: The Saga Anthology of Ghost Stories ")]), _vm._v("and was reprinted in "), _c('span', {
    staticClass: "CharOverride-5"
  }, [_vm._v("The Best Fantasy and Horror 2020.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-365675f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9780802158017-4.vue
// module id = 75
// module chunks = 0